import { render, staticRenderFns } from "./AssignResourceDialog.vue?vue&type=template&id=dbffbc34"
import script from "./AssignResourceDialog.vue?vue&type=script&lang=js"
export * from "./AssignResourceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports